import { FormControl, InputLabel, MenuItem } from "@mui/material";
import { TagColorKind, TagView } from "generated/graphql";
import { forceGQLArray } from "Backend";
import { TagChip } from "../BetterResponseTable/TagChip";
import PSelect from "components/PSelect";
import { ColorSwatch } from "../../routes/lens-editor/tags/TagName";
import { compareTag } from "components/tags/utils";

interface TagSelectProps {
  tagMap: Map<string, TagView>;
  label: string;
  value: string[];
  onChange: (value: string[]) => void;
}

export default function TagSelect({ label, tagMap, value, onChange }: TagSelectProps) {
  return (
    <FormControl size="small" className="grow">
      <InputLabel variant="outlined">{label}</InputLabel>
      <PSelect<string[]>
        multiple
        label={label}
        value={value}
        onChange={(evt) => {
          const v = evt.target.value;
          onChange(forceGQLArray(v));
        }}
        renderValue={(selectedTags: string[]) => (
          <div className="flex gap-2 flex-wrap">
            {selectedTags
              .map((selected) => {
                return (
                  tagMap.get(selected) || {
                    displayName: "Unknown Tag",
                    systemName: "unknown",
                    color: TagColorKind.Gray,
                    rank: Number.MAX_SAFE_INTEGER,
                  }
                );
              })
              .toSorted(compareTag)
              .map((tag, index) => {
                return <TagChip active key={index} tag={tag} />;
              })}
          </div>
        )}>
        {Array.from(tagMap.values())
          .toSorted(compareTag)
          .map((tag) => (
            <MenuItem key={tag.systemName} className="flex items-center justify-between" value={tag.systemName}>
              {tag.displayName}
              <ColorSwatch style={{ backgroundColor: tag.colorValue }} />
            </MenuItem>
          ))}
      </PSelect>
    </FormControl>
  );
}
